import { useRoleBasedView } from "hooks/useRoleBasedView";
import { AdvanceTaxAndProfitsDashboardCustomer } from "./AdvanceTaxAndProfitsDashboardCustomer";
import { AdvanceTaxAndProfitsDashboardAdmin } from "./AdvanceTaxAndProfitsDashboardAdmin";

export const AdvanceTaxAndProfitsDashboard = () => {
  const { isCustomer } = useRoleBasedView();

  if (isCustomer) return <AdvanceTaxAndProfitsDashboardCustomer />;

  return <AdvanceTaxAndProfitsDashboardAdmin />;
};
